<template>
  <section class="sys-manage">
    <g-breadcrumb bread="系统管理, 系统设置, 推送设置" />
    <SearchForm>
      <el-form ref="form" inline :model="form" :rules="rules" label-width="130px">
        <el-form-item label="复习课完成时间" prop="num">
          <el-input v-model="form.num" type="text" onkeyup="value=value.replace(/[^\d]/g,'')" maxlength="20" style="width:60%;" placeholder="请输入" /> <span>天</span>
        </el-form-item>
        <el-button type="success" @click="saveDate">保存</el-button>
      </el-form>
    </SearchForm>

    <TableContainer title="复习课推送周期">
      <div class="tableContainer">
        <el-table :data="installDetailList" :cell-style="isCenter">
          <el-table-column prop="materialName" label="教材等级" min-width="130">
            <template slot-scope="scope">
              <span>{{ scope.row.materialName }}</span>
              <el-button class="add-btn" size="mini" @click="addCourseTye(scope.row,scope.$index)">添加课程类型</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="" label="课程类型" min-width="120">
            <template slot-scope="scope">
              <div v-for="(item,x) in scope.row.curriculumTypeList" :key="item.x" class="wai">
                <div v-for="(ele,index) in scope.row.curriculumTypeList" v-show="x === index" :key="ele.index" class="left">
                  <el-select v-model="scope.row.curriculumTypeList[index].curriculumType" size="mini" placeholder="请选择">
                    <el-option
                      v-for="it in options"
                      :key="it.dicCode"
                      :label="it.dicName"
                      :value="it.dicCode"
                    />
                  </el-select><el-button class="del-btn" :disabled="scope.row.curriculumTypeList.length == 1" size="mini" @click="delType(scope.$index,index)">删除</el-button>
                </div>
                <div class="rihgt" style="opacity:0;width:0px">
                  <div v-for="(ele) in item.date" :key="ele.y" class="ct2">
                    <div class="hang" style="margin:5px">
                      <el-button size="mini">删除</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="推送周期（天）" min-width="120">
            <template slot-scope="scope">
              <div v-for="(item,x) in scope.row.curriculumTypeList" :key="item.x" class="wai">
                <div v-for="(ele,index) in scope.row.curriculumTypeList" v-show="x === index" :key="ele.index" style="width:10px" class="left">
                  <el-select v-model="scope.row.curriculumTypeList[index].curriculumType" style="opacity:0" size="mini" placeholder="请选择">
                    <el-option
                      v-for="it in options"
                      :key="it.dicCode"
                      :label="it.dicName"
                      :value="it.dicCode"
                    />
                  </el-select><el-button style="opacity:0" size="mini">删除</el-button>
                  <!-- 上面这一部分隐藏掉了 -->
                </div>
                <div class="rihgt">
                  <div v-for="(ele,y) in item.date" :key="ele.y" class="ct2">
                    <div class="hang" style="margin:5px">
                      <el-input v-model.number="scope.row.curriculumTypeList[x].date[y]" onkeyup="value=value.replace(/[^\d]/g,'')" type="text" size="mini" maxlength="20" style="width:30%" placeholder="请输入数字" />
                      <el-button v-if="y === scope.row.curriculumTypeList[x].date.length-1 " class="add-btn" size="mini" @click="addPeriod(scope.$index,x,y)">添加</el-button>
                      <el-button :disabled="scope.row.curriculumTypeList[x].date.length == 1" class="del-btn" size="mini" @click="delPeriod(scope.$index,x,y)">删除</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </TableContainer>

  </section>
</template>
<script>
import { getDictoryInfoByCode } from '@api/api_common'
import { addInstall, selectInstallDetail } from '@api/teachBookManagement/sysManagement'
export default {
  data() {
    return {
      activeTabsName: '1',
      rules: {
        num: [
          { required: true, message: '请输入', trigger: 'blur' }
        ]
      },
      options: [],
      installDetailList: [],
      form: {
        num: ''
      }
    }
  },
  created() {
    getDictoryInfoByCode('REVIEWRE_DEFINITION').then(res => {
      this.options = res
    })
    this.getSelectInstallDetail()
  },
  methods: {
    getSelectInstallDetail() {
      selectInstallDetail().then(res => {
        this.form.num = res.num
        this.installDetailList = res.installDetailList
      })
    },
    addCourseTye(row, index) {
      // console.log('行数据')
      // console.log(row)
      if (this.installDetailList[index].curriculumTypeList.length >= 5) {
        this.$message.error('类型已满，不能超过5个类型。')
        return
      }
      this.installDetailList[index].curriculumTypeList.push({ 'curriculumType': '请选择', 'date': [1] })
    },
    delType(rowNo, index) {
      this.installDetailList[rowNo].curriculumTypeList.splice(index, 1)
    },
    addPeriod(rowNo, x, y) {
      if (this.installDetailList[rowNo].curriculumTypeList[x].date.length >= 2) {
        this.$message.error('周期已满，不能超过2个。')
        return
      }
      this.installDetailList[rowNo].curriculumTypeList[x].date.push(1)
    },
    delPeriod(rowNo, x, y) {
      this.installDetailList[rowNo].curriculumTypeList[x].date.splice(y, 1)
    },
    isRepeat(arr) {
      // 判断数组是否存在重复的元素。
      var hash = {}
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true
        }
        // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
        hash[arr[i]] = true
      }
      return false
    },
    handleTabsClick() {},
    isCenter({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return 'border-right: solid 1px #ebeef5; margin-bottom: -5px'
      }
      if (columnIndex === 1) {
        // return 'border-bottom: solid 1px red;'
      }
    },
    saveDate() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let pass = true // 声明一个变了来存储是否验证通过。
          this.installDetailList.forEach(ele => {
            const num = ele.curriculumTypeList.findIndex((item) => item.curriculumType === '请选择')
            if (num > -1) {
              this.$message.error(ele.materialName + '第' + (num + 1) + '项请选择课程类型')
              pass = false
            }
          })
          if (!pass) {
            return false
          }
          const copyArray = JSON.parse(JSON.stringify(this.installDetailList))
          copyArray.forEach((ele, index) => {
            // 添加要给course课程编码的数组。
            ele.course = []
            ele.curriculumTypeList.forEach(item => {
              ele.course.push(item.curriculumType)
            })
          })
          // console.log('copyArray')
          // console.log(copyArray)
          // 如果存在多个重复的，那么依次提示，用find发现第一个项，提示。
          const firstItem = copyArray.find(ele => this.isRepeat(ele.course))
          if (firstItem) {
            this.$message.error(firstItem.materialName + '课程类型存在重复,请更正')
            return false
          }
          const params = {
            num: Number(this.form.num),
            installDetailList: this.installDetailList
          }
          addInstall(params).then(res => {
            this.$message.success('保存成功！')
            this.getSelectInstallDetail()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.sys-manage{

  // /deep/ .el-input__inner{
  //   /*background:#fff*/
  // }
  .el-tabs__content{
    max-height: auto;
  }
  .wai{
    display: flex;
    flex-direction: row;
    // justify-content: center;
    border-bottom:#ebeef5 solid 1px;
    margin-left: -20px;
    margin-right: -20px;
    margin-bottom: -5px;
    margin-top: 5px;
    padding-bottom: 5px;
    padding-top: 7px;
    .left{
      // border: pink solid 1px ;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 300px;
    }
    .right{
      // border: red solid 1px ;
       display: flex;
      flex-direction: column;
      // justify-content: center;
      .ct2{
        // height: 80px;
        // border: springgreen solid 1px;
        .hang{
          // border: springgreen solid 1px;
          display: flex;
          flex-direction: row;
          // justify-content: center;
          // height: 60px
        }
      }

    }
  }
  .add-btn{
    background-color: #59A82E;
    border-radius: 10px;
    color: #fbfdfa;
    margin-left: 10px;
  }
  .del-btn{
    background-color: #fcda6f;
    border: #fcda6f solid 1px;
    border-radius: 10px;
    color: #fbfdfa;
    margin-left: 10px;
  }
}
</style>
